module.exports = __webpack_public_path__ + "img/round-warning-24px.66e6e442.svg";